import React from 'react';
import styled from 'styled-components/macro';

import { ReactComponent as catalogue } from 'icons/releaseTypes/icon-catalogue.svg';
import { ReactComponent as frontline } from 'icons/releaseTypes/icon-frontline.svg';

const StyledIcon = styled.svg`
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
`;

const SmallStyledIcon = styled.svg`
  width: 1.2rem;
  min-width: 1.2rem;
  height: 1.2rem;
  margin-left: -0.3rem;
  margin-top: 0.2rem;
`;

interface IReleaseIconProps {
  releaseType: string;
  showHiddenPlaceholder?: boolean;
  small?: boolean;
}

const ReleaseIcon: React.FC<IReleaseIconProps> = (props) => {
  const { releaseType, showHiddenPlaceholder, small } = props;

  const icons = {
    catalogue,
    frontline,
  };

  const releaseName = releaseType.toLowerCase().replace(/\s/g, '');

  const hasNoIcon = releaseName in icons === false;
  if (hasNoIcon && showHiddenPlaceholder) return <StyledIcon as="div" />;
  if (hasNoIcon) return null;

  const iconComponent = releaseName === 'catalogue' ? catalogue : frontline;

  return small ? (
    <SmallStyledIcon as={iconComponent} />
  ) : (
    <StyledIcon as={iconComponent} />
  );
};

export default ReleaseIcon;
